import gql from 'graphql-tag';

export const deleteNodeMutation = gql`
    mutation DeleteNodeMutation($id: ID!) {
        nodeDelete(id: $id)
    }
`;